export function arrayify<T>(arg?: T | T[]): T[] {
  return arg !== undefined ? (Array.isArray(arg) ? arg : [arg]) : [];
}

export const replaceAll = (str: string, find: string, replace: string) => {
  return str.replace(new RegExp(find, 'g'), replace);
};
